import React from 'react';
import { connect } from 'react-redux';
import { setActiveLanguage } from 'react-localize-redux';

import DropdownMenu from 'react-dd-menu';

class LanguageSelector extends React.Component {
    constructor(props) {
        super(props);

        // This binding is necessary to make `this` work in the callback
        this.handleClick = this.handleClick.bind(this);
        this.state = {
            isMenuOpen: false
        };
    }

    toggle = () => {
        this.setState({ isMenuOpen: !this.state.isMenuOpen });
    };

    close = () => {
        this.setState({ isMenuOpen: false });
    };

    handleClick(event) {
        var currentLanguage = this.props.activeLanguage;
        var clickedLanguage = event.target.attributes.getNamedItem('data').value;
        //if the current language equals the clicked language do nothing
        if(currentLanguage === clickedLanguage){
            return false;
        }
        //change language to the selected one
        this.props.dispatch(setActiveLanguage(clickedLanguage));
    }

    render() {
        let menuOptions = {
            isOpen: this.state.isMenuOpen,
            close: this.close.bind(this),
            className: 'btn-group', 
            toggle: <button className="dropdown-toggle" onClick={this.toggle.bind(this)} ><img src={'images/'+ this.props.activeLanguage +'-flag.jpg'} alt={this.props.activeLanguage +' flag'} className={ this.props.activeLanguage } /> <span className="caret"></span></button>
        };
        
        return (
            <ul>
                <li className="languages-menu">
                    <DropdownMenu {...menuOptions}>
                        {this.props.languages.map (value => <li data={value} key={value.toString()}><span data={value} className="lang_selector" onClick={this.handleClick}><img data={value} src={'images/'+ value +'-flag.jpg'} alt={value +' flag'} className={value} /></span></li>)}
                    </DropdownMenu>
                </li>
            </ul>
        )
    }
}

const mapStateToProps = (stat) => {
    function getLanguages (state){
        return state.locale.languages;
    }

    function getActiveLan (state) {
        var language = getLanguages(state).find(language => language.active === true);
        return language;
    };
    var actl = getActiveLan(stat);

    var actc = actl.code;

    return {
        activeLanguage: actc
    };
};

export default connect(mapStateToProps)(LanguageSelector);



// WEBPACK FOOTER //
// ./src/components/menu/language-selector.jsx